import { type AuthenticatedUser } from "@/hooks/use-authenticated-user";

export const isRestrictedEsgUser = (userData: AuthenticatedUser): boolean => {
  const isEsgUser = userData.features.includes("esg_user");
  const isAdmin = userData.features.includes("organization_admin") || userData.features.includes("superadmin");
  return isEsgUser && !isAdmin;
};
